"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaintFieldName = void 0;
const react_1 = __importDefault(require("react"));
const typestyle_1 = require("typestyle");
const index_1 = require("../../Type/index");
const Main = typestyle_1.style({
    display: 'flex',
    flexFlow: 'row no-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
const Indent = typestyle_1.style({
    marginLeft: 2,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
});
exports.PaintFieldName = ({ args, data, name }) => {
    if (args && args.length > 0) {
        return (react_1.default.createElement("div", { className: Main },
            react_1.default.createElement("span", null, name),
            "(",
            args.map((a, i) => (react_1.default.createElement("div", { className: Indent, key: a.name },
                react_1.default.createElement(exports.PaintFieldName, { data: a.data, name: a.name, args: a.args }),
                ":",
                react_1.default.createElement(index_1.PaintType, { type: a.type }),
                ","))),
            ")"));
    }
    return react_1.default.createElement("span", null, name);
};
